export interface User {
    uuid: string;
    nombre: string;
    apellido: string;
    email: string;
    rol?: string;
    imagen?: string;
    token?: string;
    refreshToken?: string;
    activo: boolean;
    deleted_at?: Date;
    editPermissions?: string;
}

export enum Roles {
    admin = 'ADMIN',
    user = 'USER',
    specialist = 'ESPECIALISTA',
}
